import React, { useEffect, useState } from 'react';

import { useGetAccountInfo, useGetIsLoggedIn } from '@multiversx/sdk-dapp/hooks';
import { BigUIntValue, BytesValue, U32Value } from '@multiversx/sdk-core/out';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import axios from 'axios';
import BigNumber from 'bignumber.js/bignumber';
import clsx from 'clsx';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CustomButton } from 'components';
import { contracts, ElrondApiUrl, farmCost } from 'config/config';
import { BigZero, coinNames } from 'helpers/constant';
import { convertEsdtToWei, convertWeiToEsdt, getSymbol, shortenEsdt } from 'helpers/utils';
import { useInteraction } from 'Interaction';
import { routeNames } from 'routes';

import styles from './styles.module.scss';
import { CustomInput } from 'components/CustomInput';
import { Box, Step, StepIconProps, StepLabel, Stepper, styled } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 8,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',

            background: '#FFBC0A'
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
            background: '#FFBC0A'
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 2,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#D3D3D3',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
    // border: '1px solid gray',
    zIndex: 1,
    color: '#000',
    width: 20,
    height: 20,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    ...(ownerState.active && {

        // backgroundImage:
        //     'linear-gradient( 136deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
        background: '#FFBC0A',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        color: '#000',
    }),
    ...(ownerState.completed && {
        // backgroundImage:
        //     'linear-gradient( 136deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
        background: '#FFBC0A',
        color: '#000',
    }),
}));

function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
        1: <div>1</div>,
        2: <div>2</div>,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

export const CreateFarm = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [pairId, setPairId] = useState(0);
    const [lpTokenId, setLpTokenId] = useState('');
    const [lpTokenIds, setLpTokenIds] = useState<string[]>([]);
    const [rewardTokenId, setRewardTokenId] = useState('');

    const [currentFarm, setCurrentFarm] = useState<any>(undefined);
    const [rewardBalance, setRewardBalance] = useState<BigNumber>(BigZero);
    const [secondRewardBalance, setSecondRewardBalance] = useState<BigNumber>(BigZero);
    const [depositAmount, setDepositAmount] = useState<BigNumber>(BigZero);

    const [rewardTokenAmount, setRewardTokenAmount] = useState(BigZero);

    const navigate = useNavigate();
    const isLoggedIn = useGetIsLoggedIn();

    const { userPairInfos, userFarmInfos, callMethod } = useInteraction();
    const { account: {address: userAddress, balance: userBalance} } = useGetAccountInfo();

    useEffect(() => {
        const lps: string[] = [];

        for(const pairInfos of userPairInfos) {
            if(pairInfos.lp_token_id) {
                lps.push(pairInfos.lp_token_id);
            }
        }

        setLpTokenIds(lps);

        if(lps.length && !lpTokenId) {
            setLpTokenId(lps[0]);
        }
    }, [userPairInfos]);

    useEffect(() => {
        for(const pairInfos of userPairInfos) {
            if(pairInfos.lp_token_id == lpTokenId) {
                setPairId(pairInfos.pair_id.toNumber());
            }
        }
    }, [lpTokenId, userPairInfos]);

    useEffect(() => {
        setActiveStep(0);
        setCurrentFarm(undefined);

        for(const farm of userFarmInfos) {
            if(BigZero.isEqualTo(farm.reward_pool_size)) {
                setActiveStep(1);
                setCurrentFarm(farm);

                break;
            }
        }
    }, [userFarmInfos]);

    useEffect(() => {
        (async () => {
          if(currentFarm && userAddress) {
            try {
                if(currentFarm.reward_token_id == 'EGLD') {
                    const balance = new BigNumber(userBalance || 0);

                    setRewardBalance(convertWeiToEsdt(balance, 18));
                } else {
                    const { data } = await axios.get(`${ElrondApiUrl}/accounts/${userAddress}/tokens/${currentFarm?.reward_token_id}`);
            
                    const balance = new BigNumber(data.balance || 0);
                    setRewardBalance(convertWeiToEsdt(balance, currentFarm.reward_token_decimal));
                }
            } catch (error) {
                console.log(error);
            }
          }
        })();
      }, [currentFarm]);

    const createFarm = async () => {
        if(
            pairId === 0 ||
            rewardTokenId.length === 0 ||
            BigZero.isEqualTo(rewardTokenAmount)
        ) return;

        try {
            let decimals;
            if(rewardTokenId != 'EGLD') {
                const { data } = 
                    await axios.get(`${ElrondApiUrl}/tokens/${rewardTokenId}`);
                
                if(data.type != 'FungibleESDT') {
                    throw 'Only FungibleESDT is available for farm rewards';
                }
    
                decimals = data.decimals >= 0 ?  data.decimals : 18;
            } else {
                decimals = 18;
            }
    
            await callMethod({
                contract: contracts.Farm,
                method: 'createPool',
                args: [
                    new U32Value(pairId),
                    BytesValue.fromUTF8(lpTokenId),
                    BytesValue.fromUTF8(rewardTokenId),
                    new U32Value(decimals),
                    new BigUIntValue(convertEsdtToWei(rewardTokenAmount, decimals)),
                ],
                egld: farmCost
            });
        } catch(error: any) {
            if(error?.response) {
                const { message } = error.response.data;

                toast.error(message);
            } else if(typeof(error) === 'string') {
                toast.error(error);
            }
            console.log(error);
        }
    };

    const depositReward = async() => {
        if(
            BigZero.gte(depositAmount) ||
            !currentFarm ||
            !userAddress
        ) return;

        try {
            const isEGLD = currentFarm.reward_token_id == 'EGLD' ? true : false;

            // console.log('>>>', depositAmount.toString(), currentFarm);

            await callMethod({
                contract: contracts.Farm,
                method: 'depositReward',
                args: [
                    new U32Value(currentFarm.pool_id),
                ],
                fts: isEGLD ? [] : [
                    {
                        token: currentFarm.reward_token_id,
                        amount: depositAmount,
                        decimals: currentFarm.reward_token_decimal.toNumber()
                    },
                ],
                egld: isEGLD ? depositAmount : BigZero
            });
        } catch(error: any) {
            console.log(error);
        }
    };

    const getBody = () => {
        if(activeStep == 0) {

            return(
                <div className={styles.cardBody}>
                    <h3 className='text-white text-left mb-4'>Create New Farm</h3>
                    <h6 className='text-white text-left'>LP Token</h6>
                    <Form.Select
                        className={styles.lp}
                        aria-label='Lp Token Selector'
                        onChange={(e) => setLpTokenId(e.target.value)}
                        value={lpTokenId}
                    >
                        {
                            lpTokenIds.map((token ,index) => 
                                <option value={token} key={index}>
                                    {token}
                                </option>
                            )
                        }
                    </Form.Select>
                    <span className={styles.warning}>Only Swap Creator can create his lp Farm</span>
                    <h6 className='text-white text-left mt-4'>Reward Token</h6>
                    <input
                        value={rewardTokenId}
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        type='text'
                        placeholder='Token Identifier'
                        onChange={(e) => {
                            const parts = e.target.value.split('-');
                            let token = parts[0].toUpperCase();
                            if(parts.length > 1) {
                                token =  token + '-' + parts[1];
                            }
    
                            setRewardTokenId(token);
                        }}
                    />
                    <span className={styles.warning}>EGLD or ESDT TokenIdentifier</span>

                    <h6 className='text-white text-center mt-4'>Annual Reward Amount Per 1 LP</h6>
                    <CustomInput
                        className={styles.amount}
                        leftAlign={true}
                        noMax={true}
                        placeholder={'Amount'}
                        value={rewardTokenAmount}
                        setAmount={(newAmount: BigNumber) => {
                            setRewardTokenAmount(newAmount);
                        }}
                    />
                    <span className='text-info text-center mt-4'>Cost is 2 EGLD</span>
                    <CustomButton
                        className={styles.applyButton}
                        onClick={() => createFarm()}
                    >
                        Create Farm
                    </CustomButton>
                </div>
            );
        } else {
            return (
                <div className={styles.cardBody}>
                    <h3 className='text-white text-left my-4'>DEPOSIT INITIAL REWARD</h3>
                    <h6 className='text-white text-left'>Reward Token</h6>
                    <span className='text-info'>{currentFarm?.reward_token_id}</span>
                    <span className='text-white'>Balance: {shortenEsdt(rewardBalance)}</span>
                    <CustomInput
                        className={clsx(styles.import, 'flex-grow-1 w-100')}
                        placeholder='Reward Token Amount'
                        value={depositAmount}
                        maxValue={rewardBalance}
                        setAmount={(value: BigNumber) => {
                            if(value.lte(rewardBalance)) {
                                setDepositAmount(value);
                            }
                        }}
                    />
                    <CustomButton
                        className={styles.applyButton}
                        onClick={() => depositReward()}
                    >
                        Deposit Reward
                    </CustomButton>
                </div>
            );
        }
    };

    useEffect(() => {
        if(!isLoggedIn) {
            navigate(routeNames.unlock);
        }
    }, [isLoggedIn]);

    const steps = ['Create Farm Pool', 'Deposit Initial Rewards'];
    
    return(
        <div className='d-flex flex-column flex-fill align-items-center justify-content-start'>
            <div className={styles.body}>
                <div
                    onClick={() => navigate('/farm')}
                    className={clsx(styles.back, 'w-100 d-flex justify-content-start text-white')}
                >
                    <NavigateBeforeIcon />
                    Back to Farm
                </div>
                <Box sx={{ width: '100%', marginTop: '40px' }}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                >
                                    <span style={{ color: '#D3D3D3', fontSize: '13px' }}>{label}</span>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                
            </div>
            <div className={clsx(styles.card, 'card shadow-sm mx-5 mt-3')}>
                {getBody()}
            </div>
        </div>
    );
};
